/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {formatLabel, PieSeriesComponent} from '@swimlane/ngx-charts';

@Component({
    selector: 'svg:g[dash-gis-custom-pie-series]',
    templateUrl: './custom-pie-series.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomPieSeriesComponent extends PieSeriesComponent {

    @Input() colors;
    @Input() series: any = [];
    @Input() dims;
    @Input() innerRadius = 60;
    @Input() outerRadius = 80;
    @Input() explodeSlices;
    @Input() showLabels;
    @Input() gradient: boolean;
    @Input() activeEntries: any[];
    @Input() labelFormatting: any;
    @Input() trimLabels = true;
    @Input() maxLabelLength = 10;
    @Input() tooltipText: (o: any) => any;
    @Input() tooltipDisabled = false;
    @Input() tooltipTemplate: TemplateRef<any>;
    @Input() animations = true;

    @Output() select = new EventEmitter();
    @Output() activate = new EventEmitter();
    @Output() deactivate = new EventEmitter();
    @Output() dblclick = new EventEmitter();

    constructor() {
        super();
    }

    labelText(myArc): string {
        if (this.labelFormatting) {
            return this.labelFormatting(myArc);
        }
        return this.label(myArc);
    }

}
